import './styles.scss'
import { TestReport } from './lib/test-report'
import { runAllSequentially } from './lib/task'
import { Suite, SUITES } from './lib/suites'
import {} from './lib/specs'

//
//
//

const getParameterByName = (name: string, url?: string) => {
  url = url || location.href
  name = name.replace(/[[\]]/g, '\\$&')
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

const getId = (str: string) => {
  return str.replace(/\s/gm, '')
}

// Available Params:
// - iceServer
// - turnUsername
// - turnCredential
// - iceStunPort
// - iceTurnPor
// - Suite

const iceServer = getParameterByName('iceServer') || 'us-04.sylaps.com',
  turnUsername =
    getParameterByName('turnUsername') ||
    'sylaps-MEL-9080337e-9080337e-5969-167c-c66b-d903b1c25535',
  turnCredential =
    getParameterByName('turnCredential') || '7ba08b11325489b74cfb7b588275c86c',
  iceStunPort = getParameterByName('iceStunPort') || '3478',
  iceTurnPort = getParameterByName('iceTurnPort') || '5349'

const testsSettings = {
  iceCandidates: {
    stunURI: 'stun:' + iceServer + ':' + iceStunPort,
    turnURI: [
      'turn:' + iceServer + ':' + iceTurnPort + '?transport=udp',
      'turn:' + iceServer + ':' + iceTurnPort + '?transport=tcp',
    ].join(','),
    turnUsername: turnUsername,
    turnCredential: turnCredential,
  },
}

let testsSuitesRunner: any = null
let testsSuitesRunning = false
let testLastUpdate = -1
let testsSuitesErr = null
let testsSuitesScrolled = false

window.addEventListener('scroll', () => {
  testsSuitesScrolled = true
})

const startTest = (suites: any[]) => {
  if (testsSuitesRunning) {
    throw Error('Tests already running')
  }

  testsSuitesScrolled = false

  const testsTestReport = new TestReport(testsSettings)
  const testsSuites = suites.map((suite: any) => {
    const testSuite = new Suite(testsTestReport, suite.name)
    suite.tests
      .filter((test: any) => test.enabled !== false)
      .forEach((test: any) => testSuite.addTest(test.name, test.spec))
    return testSuite
  })

  renderSuites(testsSuites)
  testsSuitesRunning = true
  testsSuitesRunner = runAllSequentially(testsSuites)
  return testsSuitesRunner.promise
    .then(
      function success() {
        updateSuites(testsSuites)
        testLastUpdate = Date.now()
      },
      function failure(err: Error) {
        updateSuites(testsSuites)
        testLastUpdate = Date.now()
        testsSuitesErr = err
      },
      function update() {
        updateSuites(testsSuites)
        testLastUpdate = Date.now()
      },
    )
    .finally(() => {
      updateSuites(testsSuites)
      testsSuitesRunning = false
      testLastUpdate = Date.now()
    })
}

const stopTest = () => {
  if (!testsSuitesRunning) {
    return
    throw Error('Tests are not running')
  }
  testsSuitesRunner?.cancel()
}

const selectTestSuites = (suites: any[], testsEl: HTMLSelectElement) => {
  const optgroupEls = testsEl.querySelectorAll('optgroup')
  Array.from(optgroupEls).forEach((optgroupEl) => {
    const suite = suites.find((suite) => suite.name === optgroupEl.label)
    const optionEls = optgroupEl.querySelectorAll('option')
    Array.from(optionEls).forEach((optionEl) => {
      const test = suite.tests.find(
        (test: any) => test.name === optionEl.textContent,
      )
      test.enabled = optionEl.selected
    })
  })
}

const renderForm = (suites: any[], suiteFilter?: string) => {
  const stunURIEl = document.getElementById('stunURI') as HTMLInputElement
  const turnURIEl = document.getElementById('turnURI') as HTMLInputElement
  const turnUsernameEl = document.getElementById(
    'turnUsername',
  ) as HTMLInputElement
  const turnCredentialEl = document.getElementById(
    'turnCredential',
  ) as HTMLInputElement
  const testSettingsForm = document.getElementById(
    'testSettings',
  ) as HTMLFormElement
  const testsEl = document.getElementById('tests') as HTMLSelectElement

  //
  stunURIEl.value = testsSettings.iceCandidates.stunURI
  turnURIEl.value = testsSettings.iceCandidates.turnURI
  turnUsernameEl.value = testsSettings.iceCandidates.turnUsername
  turnCredentialEl.value = testsSettings.iceCandidates.turnCredential

  testsEl.innerHTML = ''
  suites.forEach((suite: any) => {
    const suiteEl = document.createElement('optgroup')
    suiteEl.label = suite.name

    suite.tests.forEach((test: any) => {
      const testEl = document.createElement('option')
      testEl.textContent = test.name
      testEl.value = getId(test.name)

      const isSelected =
        !suiteFilter || (suiteFilter && suite.name.indexOf(suiteFilter) !== -1)

      testEl.selected = isSelected
      suiteEl.append(testEl)
    })

    testsEl.append(suiteEl)
  })

  selectTestSuites(suites, testsEl)

  testsEl.addEventListener('change', (event) => {
    event.preventDefault()
    event.stopPropagation()
    selectTestSuites(suites, testsEl)
  })

  const testsResultsEl = document.getElementById('testsResults')
  const startTestsEl = document.getElementById('startTests')
  const resetTestsEl = document.getElementById('resetTests')
  const noTestsEl = document.getElementById('noTests')
  const stopTestsEl = document.getElementById('stopTests')

  testSettingsForm.addEventListener('submit', (event) => {
    event.preventDefault()
    event.stopPropagation()

    // set settings
    testsSettings.iceCandidates.stunURI = stunURIEl.value
    testsSettings.iceCandidates.turnURI = turnURIEl.value
    testsSettings.iceCandidates.turnUsername = turnUsernameEl.value
    testsSettings.iceCandidates.turnCredential = turnCredentialEl.value

    const submitter = event.submitter
    if (submitter === startTestsEl) {
      startTestsEl.classList.add('d-none')
      stopTestsEl.classList.remove('d-none')
      stopTestsEl.removeAttribute('disabled')
      startTest(suites).finally(() => {
        stopTestsEl.classList.add('d-none')
        startTestsEl.classList.remove('d-none')
        stopTestsEl.removeAttribute('disabled')
      })
    } else if (submitter === resetTestsEl) {
      testsResultsEl.innerHTML = ''
      stopTestsEl.setAttribute('disabled', '')

      const optionsEls = testsEl.querySelectorAll('option');
      optionsEls.forEach((optionsEl) => optionsEl.selected = true)
      stopTest()

    } else if (submitter === stopTestsEl) {
      stopTestsEl.setAttribute('disabled', '')
      stopTest()
    } else if (submitter === noTestsEl) {
      testsEl.selectedIndex = -1
      stopTest()
    }
  })
}

const renderSuites = (suites: Suite[]) => {
  const testsResultsEl = document.getElementById('testsResults')
  testsResultsEl.innerHTML = ''
  suites.forEach((suite: any) => {
    const suiteId = getId(suite.name)

    const cardEl = document.createElement('div')
    cardEl.className = 'card'
    const cardBodyEl = document.createElement('div')
    cardBodyEl.className = 'card-body'
    const cardTitleEl = document.createElement('h3')
    cardTitleEl.className = 'card-title'
    cardTitleEl.textContent = suite.name
    cardBodyEl.append(cardTitleEl)
    cardEl.append(cardBodyEl)

    const accordionEl = document.createElement('div')
    accordionEl.className = 'accordion'
    accordionEl.id = suiteId

    if (suite.tests.length) {
      testsResultsEl.append(cardEl)
    }

    suite.tests.forEach((test: any) => {
      const testId = getId(test.name)

      const accordionItemEl = document.createElement('div')
      accordionItemEl.className = 'accordion-item'
      const accordionHeaderEl = document.createElement('h2')
      accordionHeaderEl.className = 'accordion-header'
      accordionHeaderEl.id = testId + '-Header'

      const accordionButtonEl = document.createElement('button')
      accordionButtonEl.className = 'accordion-button collapsed'
      accordionButtonEl.type = 'button'
      accordionButtonEl.setAttribute('data-bs-toggle', 'collapse')
      accordionButtonEl.setAttribute('data-bs-target', '#' + testId)
      accordionButtonEl.setAttribute('aria-expanded', 'false')
      accordionButtonEl.setAttribute('aria-controls', testId)
      accordionButtonEl.textContent = test.name

      accordionButtonEl.addEventListener('click', () => {
        test.wasOpened = !test.wasOpened
        accordionButtonEl.dataset.open = String(test.wasOpened)
        if (accordionButtonEl.dataset.open === 'true') {
          accordionButtonEl.focus({ preventScroll: true })
        }
      })

      accordionHeaderEl.append(accordionButtonEl)
      accordionItemEl.append(accordionHeaderEl)
      accordionEl.append(accordionItemEl)

      const accordionCollapseEl = document.createElement('div')
      accordionCollapseEl.className = 'accordion-collapse collapse hide'
      accordionCollapseEl.id = testId
      accordionCollapseEl.setAttribute('data-bs-parent', '#' + suiteId)
      accordionCollapseEl.setAttribute('aria-labelledby', testId + '-Header')
      const accordionBodyEl = document.createElement('div')
      accordionBodyEl.className = 'accordion-body'
      const accordionStatusEl = document.createElement('div') as HTMLDivElement
      accordionStatusEl.className = 'status'
      accordionStatusEl.textContent = 'No started'

      const progressEl = document.createElement('div')
      progressEl.className = 'progress d-none'
      const progressBarEl = document.createElement('div')
      progressBarEl.className =
        'progress-bar progress-bar-striped progress-bar-animated'
      progressBarEl.role = 'progressbar'
      progressBarEl.setAttribute('aria-label', 'Animated striped example')
      progressBarEl.setAttribute('aria-valuenow', '75')
      progressBarEl.setAttribute('aria-valuemin', '0')
      progressBarEl.setAttribute('aria-valuemax', '100')
      progressBarEl.setAttribute('style', 'width: 100%')
      progressEl.append(progressBarEl)

      const accordionOutputEl = document.createElement('pre')
      accordionOutputEl.className = 'output d-none'

      accordionBodyEl.append(accordionStatusEl)
      accordionBodyEl.append(progressEl)
      accordionBodyEl.append(accordionOutputEl)
      accordionCollapseEl.append(accordionBodyEl)
      accordionItemEl.append(accordionCollapseEl)
    })

    cardBodyEl.append(accordionEl)
  })
}

const updateSuites = (suites: Suite[]) => {
  suites.forEach((suite: any) => {
    suite.tests.forEach((test: any) => {
      const testId = getId(test.name)
      const accordionHeaderEl = document.getElementById(testId + '-Header')
      if (!accordionHeaderEl) {
        return
      }

      const accordionButtonEl = accordionHeaderEl.querySelector(
        '.accordion-button',
      ) as HTMLButtonElement
      const accordionCollapseEl = document.getElementById(testId)
      const accordionBodyEl =
        accordionCollapseEl.querySelector('.accordion-body')
      const accordionOutputEl = accordionBodyEl.querySelector('.output')
      const accordionStatusEl = accordionBodyEl.querySelector(
        '.status',
      ) as HTMLDivElement
      const progressEl = accordionBodyEl.querySelector('.progress')
      const progressBarEl = accordionBodyEl.querySelector('.progress-bar')
      const isOpen = test.wasOpened || test.state === 'running'

      if (isOpen) {
        accordionHeaderEl.classList.remove('collapsed')
        accordionButtonEl.classList.remove('collapsed')
        accordionCollapseEl.classList.remove('hide')
        accordionCollapseEl.classList.add('show')
      } else {
        accordionHeaderEl.classList.add('collapsed')
        accordionButtonEl.classList.add('collapsed')
        accordionCollapseEl.classList.remove('show')
        accordionCollapseEl.classList.add('hide')
      }

      // Add new output lines
      const currentOutput = accordionOutputEl.textContent.split('\n')
      const newOutput = test.output.slice(currentOutput.length - 1)
      if (newOutput.length) {
        accordionOutputEl.classList.remove('d-none')

        newOutput
          .map((line: any) => {
            const time = `${new Date(line.time).toISOString()}`
            return `[${time}] ${line.prefix} ${line.message}`
          })
          .forEach((line: string) => {
            const outputText = document.createTextNode(line + '\n')
            accordionOutputEl.append(outputText)
          })

        // Scroll bottom
        accordionOutputEl.scrollTop = accordionOutputEl.scrollHeight
      }

      if (test.state === 'running') {
        if (accordionStatusEl.dataset.state !== test.state) {
          accordionStatusEl.dataset.state = test.state
          accordionButtonEl.classList.add('running')
          progressEl.classList.remove('d-none')
          progressBarEl.classList.add('bg-primary')
          progressBarEl.classList.add('progress-bar-striped')
        }

        accordionStatusEl.textContent = `Running - duration ${test.duration}s`

        const progressValue = Math.floor(test.progressValue || '100')
        progressBarEl.setAttribute('style', `width: ${progressValue}%`)
        progressBarEl.textContent = ` ${progressValue}%`

        if (!document.querySelector('.accordion-button[data-open=true]')) {
          if (!testsSuitesScrolled) {
            accordionStatusEl.scrollIntoView({ block: 'center' })
            accordionButtonEl.focus({ preventScroll: true })
          }
        }
      } else if (accordionStatusEl.dataset.state !== test.state) {
        accordionStatusEl.dataset.state = test.state
        accordionButtonEl.classList.remove('running')
        progressBarEl.classList.remove('bg-primary')
        progressBarEl.classList.remove('progress-bar-striped')
        progressBarEl.setAttribute('style', 'width: 100%')
        progressBarEl.textContent = ``

        if (test.state === 'failure') {
          accordionStatusEl.textContent = `Failure - duration ${test.duration}s`
          progressBarEl.textContent = `Failure`
          accordionButtonEl.classList.add('failure')
          progressBarEl.classList.add('bg-danger')
        } else if (test.state === 'success') {
          accordionStatusEl.textContent = `Success - duration ${test.duration}s`
          progressBarEl.textContent = `Success`
          accordionButtonEl.classList.add('success')
          progressBarEl.classList.add('bg-success')
        } else if (test.state === 'canceled') {
          accordionStatusEl.textContent = 'Canceled'
          progressBarEl.textContent = `Canceled`
          accordionButtonEl.classList.add('warning')
          progressBarEl.classList.add('bg-warning')
        }
      }
    })
  })
}

//
//
//

const suite = getParameterByName('suite') || 'Connectivity'
renderForm(SUITES, suite)
